/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type shifts_CopyWeekRequest = {
    /**
     * How to handle conflicts with existing shifts: "skip" or "overwrite"
     */
    conflict_strategy: shifts_CopyWeekRequest.conflict_strategy;
    /**
     * Optional: only copy shifts for these employee IDs
     */
    employee_ids?: Array<string>;
    /**
     * Optional: only copy shifts assigned to these group IDs
     */
    group_ids?: Array<string>;
    /**
     * Source week start date (must be a Monday), YYYY-MM-DD format
     */
    source_start_date: string;
    /**
     * Target week start date (must be a Monday), YYYY-MM-DD format
     */
    target_start_date: string;
    /**
     * Number of consecutive weeks to copy to (1-12)
     */
    target_week_count?: number;
};
export namespace shifts_CopyWeekRequest {
    /**
     * How to handle conflicts with existing shifts: "skip" or "overwrite"
     */
    export enum conflict_strategy {
        SKIP = 'skip',
        OVERWRITE = 'overwrite',
    }
}

